module.exports = __webpack_public_path__ + "static/img/cha7-bg.1d63874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha7-bg.png
// module id = OFAO
// module chunks = 1